import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { MerchantList, ShopList, ShopDetail, ShopEntry, ShopUpdate, ShopBulkRegist } from './components';
import { ShopActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    }
})

const IdentitySelector = (state) => state.Identity;

const Shop = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    // アクションを取得
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    // トークンID, ユーザ情報を取得
    const { token, userData } = useSelector(IdentitySelector);

    const [modeInfo, setModeInfo] = useState({
        mode: 'mlist'
        , merchant_id: '', m_merchant_name: '', m_merchant_type: ''
        , s_merchant_name: '', s_shop_name: '', s_shop_type: '', s_status: ''
    });

    const [index, setIndex] = useState(0);
    const [listRefresh, setListRefresh] = useState(true);

    // props引数パラメータを取得
    const { classes } = props;

    /**
     *
     * 店舗一覧画面表示
     *
     * @param data 選択された行のデータ
     */
    const showShopList = (data, merchantName, merchantType) => {
        if (data == null || data == undefined) {
            // 編集画面などからも戻るボタンでの遷移時
            setModeInfo({
                mode: 'list'
                , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
                , s_merchant_name: modeInfo.s_merchant_name, s_shop_name: modeInfo.s_shop_name, s_shop_type: modeInfo.s_shop_type, s_status: modeInfo.s_status
            })
        }
        else {
            // 加盟店一覧から遷移時
            // storeに選択した加盟店の店舗リストを要求
            shopActions.listShops(token, data.id)
                .then(res => {
                    // 取得した店舗一覧を表示
                    setModeInfo({
                        mode: 'list'
                        , merchant_id: data.id, m_merchant_name: merchantName, m_merchant_type: merchantType
                        , s_merchant_name: '', s_shop_name: '', s_shop_type: '', s_status: ''
                    })
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }
    }

    /**
     *
     * 詳細画面表示
     *
     * @param data 選択された行のデータ
     */
    const showDetail = (data, merchantName, shopName, shopType, status) => {
        // 対象の店舗IDの店舗情報を取得
        shopActions.loadEditModel(token, data.id)
            .then(data => {
                // 詳細画面に表示切替
                setModeInfo({
                    mode: 'detail'
                    , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
                    , s_merchant_name: merchantName, s_shop_name: shopName, s_shop_type: shopType, s_status: status
                })
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 加盟店リスト画面表示
     *
     * @param data 選択された行のデータ
     */
    const showList = (merchantName, shopName, shopType, status) => {
        setListRefresh(false);
        setModeInfo({
            mode: 'mlist'
            , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , s_merchant_name: merchantName, s_shop_name: shopName, s_shop_type: shopType, s_status: status
        })
    }

    /**
     *
     * 編集画面表示
     *
     * @param data 選択された画面インデックス（店舗管理の編集では、0のみ）
     *
     */
    const showEdit = (index) => {
        setIndex(index);
        setModeInfo({
            mode: 'edit'
            , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , s_merchant_name: modeInfo.s_merchant_name, s_shop_name: modeInfo.s_shop_name, s_shop_type: modeInfo.s_shop_type, s_status: modeInfo.s_status
        })
    }

    /**
     *
     * 新規追加画面表示
     *
     */
    const showCreate = (merchantName, shopName, shopType, status) => {
        shopActions.loadEditModel(token, null)
            .then(data => {
                setModeInfo({
                    mode: 'create'
                    , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
                    , s_merchant_name: merchantName, s_shop_name: shopName, s_shop_type: shopType, s_status: status
                })
            })
            .catch(e => {
                notificationActions.showError(`新規作成データを取得できませんでした。${e.message}`);
            });
    }

    /**
     *
     * 一括登録画面表示
     *
     */
    const showBulkRegist = (merchantName, shopName, shopType, status) => {
        setModeInfo({
            mode: 'bulk'
            , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , s_merchant_name: merchantName, s_shop_name: shopName, s_shop_type: shopType, s_status: status
        })
    }

    /**
     *
     * 店舗情報の更新を行い、詳細画面表示
     * （編集画面で更新して、詳細画面を表示する際）
     *
     */
    const onUpdate = () => {
        // 更新メッセージ表示
        notificationActions.showSuccess('更新しました。');
        // 詳細画面を再表示
        setModeInfo({
            mode: 'detail'
            , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , s_merchant_name: modeInfo.s_merchant_name, s_shop_name: modeInfo.s_shop_name, s_shop_type: modeInfo.s_shop_type, s_status: modeInfo.s_status
        })
    }

    /**
     *
     * 詳細画面表示
     * （編集画面から詳細画面戻る際）
     *
     */
    const showRegComp = () => {
        // 詳細画面を再表示
        setModeInfo({
            mode: 'detail'
            , merchant_id: modeInfo.merchant_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , s_merchant_name: modeInfo.s_merchant_name, s_shop_name: modeInfo.s_shop_name, s_shop_type: modeInfo.s_shop_type, s_status: modeInfo.s_status
        })
    }

    var listClass = classes.hiddenList;
    if (modeInfo.mode == 'mlist') {
        // 加盟店一覧を表示するCSS設定
        listClass = classes.visibleList;
    }

    var content = <div></div>;
    //　加盟店の場合、店舗一覧を表示（加盟店一覧は表示しない）
    if (modeInfo.mode == 'mlist' && userData != null && userData.role == 4) {
        // 加盟店ユーザでログインされた場合は、加盟店一覧表示は行わずに店舗一覧を表示
        //（ログインしているユーザの加盟店IDで表示）
        setModeInfo({
            mode: 'list'
            , merchant_id: userData.org_id, m_merchant_name: modeInfo.m_merchant_name, m_merchant_type: modeInfo.m_merchant_type
            , s_merchant_name: modeInfo.s_merchant_name, s_shop_name: modeInfo.s_shop_name, s_shop_type: modeInfo.s_shop_type, s_status: modeInfo.s_status
        });
    }

    if (modeInfo.mode == 'list') {
        // 店舗一覧表示
        // 詳細画面用に戻るボタン（加盟店一覧画面）、追加ボタン（新規追加）、編集ボタン（編集画面）用のデリゲートを設定
        content = <ShopList onCancel={showList} onCreate={showCreate} onDetail={showDetail} onBulkRegist={showBulkRegist} refresh={listRefresh} merchantId={modeInfo.merchant_id}
            merchantName={modeInfo.s_merchant_name} shopName={modeInfo.s_shop_name} shopType={modeInfo.s_shop_type} status={modeInfo.s_status} />
    }
    if (modeInfo.mode == 'detail') {
        // 詳細画面表示
        // 詳細画面用に戻るボタン（一覧画面）、編集ボタン（編集画面）用のデリゲートを設定
        content = <ShopDetail onCancel={showShopList} onEdit={showEdit} />
    }
    if (modeInfo.mode == 'create') {
        // 新規追加画面表示
        // 新規作成画面用に戻るボタン（一覧画面）用のデリゲートを設定
        content = <ShopEntry onCancel={showShopList} merchantId={modeInfo.merchant_id} />
    }
    if (modeInfo.mode == 'edit') {
        // 編集画面表示
        // 編集画面用に編集画面インデックス、戻るボタン（詳細画面）、登録ボタン（詳細画面）用のデリゲートを設定
        content = <ShopUpdate intIndex={index} onCancel={showRegComp} onUpdate={onUpdate} />
    }
    if (modeInfo.mode == 'bulk') {
        // 一括登録画面表示
        // 一括登録画面用に戻るボタン（一覧画面）用のデリゲートを設定
        content = <ShopBulkRegist onCancel={showShopList} merchantId={modeInfo.merchant_id} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <MerchantList onList={showShopList} merchantNameSearch={modeInfo.m_merchant_name} merchantTypeSearch={modeInfo.m_merchant_type} refresh={listRefresh} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(Shop);
